// Export libraries are bundled chunks: downloads also work without a network.
export async function exportPlot(figure, { format, filename, width, height, scale = 1 }) {
  const Plotly = (await import('plotly.js/dist/plotly')).default;
  const url = await Plotly.toImage(figure, {
    format: format === 'pdf' ? 'svg' : format, width, height, scale,
  });
  if (format === 'pdf') {
    const [{ jsPDF }] = await Promise.all([import('jspdf'), import('svg2pdf.js')]);
    // Decode directly: local mode deliberately disallows fetch(data:) in CSP.
    // Plotly uses Unicode minus; PDF standard fonts encode the ASCII hyphen.
    const svgText = decodeURIComponent(url.slice(url.indexOf(',') + 1)).replace(/\u2212/g, '-');
    const svg = new DOMParser().parseFromString(svgText, 'image/svg+xml').documentElement;
    const pdf = new jsPDF({ orientation: width > height ? 'landscape' : 'portrait',
      unit: 'pt', format: [width, height] });
    await pdf.svg(svg, { x: 0, y: 0, width, height });
    pdf.save(`${filename}.pdf`);
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.${format}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
